<template>
    <div class="page white_bg">

        <header class="pageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                     style="height: 46px; ">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%">
                    <router-link class="block" :to="{name : 'search'}" style="margin-top: 3px;">
                        <i class="icon searchIcon" style="width: 18px; height: 19px; margin-top: 3px;"></i>
                    </router-link>
                </div>
            </div>
        </header>

        <div class="body">

            <div class="secondKillList">

                <div class="flexLayout item" v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
                    <div class="" style="width: 92px">
                        <div class="imageBox roundBorder4 hiddenOverflow hand alignCenter centered marginB12 font12r14"
                             style="width: 92px; height: 92px;">
                            <img class="fullSpace cover" :src="dataItem.orderBizInfo.coverImg"
                                 :alt="dataItem.orderBizInfo.title"/>
                        </div>
                    </div>
                    <div class="flex marginL8">
                        <div class="flexLayout">
                            <div class="flex titleBox alignCenter font12r14 hiddenOverflow" style="line-height: 24px; height: 48px">
                                {{dataItem.orderBizInfo.title}}
                            </div>
                            <div style="width: 40px;">
<!--                                {{ dataItem.orderBizType }}-->
                            </div>
                        </div>
                        <div>
                            <span class="red" title="秒杀价">￥{{dataItem.seckillPrice}}</span>
                            <span class="textDelete marginL24" title="原价">￥{{dataItem.orderBizInfo.price}}</span>
                        </div>
                        <div class="font12r14">
                            截止时间：{{ formatDateTime(dataItem.endTime) }}
                        </div>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何项目
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多项目了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>


        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config and data
import appConfig from '@/appConfig';
import bizTypeEnum from "@data/bizTypeEnum";
import datumTypeEnum from "@comp/datum/datumTypeEnum";
import orderBizTypeEnum from "@data/orderBizTypeEnum";

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import arrayHelper from "@util/arrayHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    name : 'secondKillIndex',
    title : '限时秒杀',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/v4/seckill/getSeckillList',
            dataPath : 'data',
            // totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo'
        }
    },
    methods : {
        viewItem(dataItem) {
            switch (dataItem.orderBizType)
            {
                case orderBizTypeEnum.DATUM.code :
                    appHelper.goToPage('secondKillDatumDetail', {
                        id : dataItem.bizId
                    });
                    break;
                default :
                    consoleApi.log('不支持的订单业务类型：' + dataItem.orderBizType);
            }
        },
        parseDatumType(datumType)
        {
            let list = datumType.split(',');
            let result = '';
            // datumTypeEnum.getTitleByCode(datumType);
            return result;
        },
        isHasDatumType(dataItem, type = '') {
            let datumTypeString = dataItem.datumType || '';
            let list = datumTypeString.split(',');
            return arrayHelper.existElement(type, list);
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.secondKillList {
    padding: 0 8px;
    .item {
        padding: 8px;
        margin-bottom: 8px;
        //border: solid #999 1px;
    }
    .item:last-child {
        margin-bottom: 0;
    }
}
</style>
